<template>
  <div class="comp-ly-recipient">
    <jw-select :trigger-props="{ updateAtScroll: true }" :placeholder="$t('请添加接收人或群组')" v-model="data.userDept" @remove="removeUserDepart" @clear="clearAll" :allow-search="false" show-footer-on-empty multiple :show-extra-options="false" style="width: 100%; border-radius: 5px" allowClear>
      <template #label="{ data }">
        <span>{{ data.value.label }}</span>
      </template>
      <template #empty>
        <xl-tree-member-modal :tree="tree" @cb="getVal($event)" :user="data.recipient?.userList">
          <jw-dsubmenu>
            <span>{{ $t('组织架构人员') }}</span>
          </jw-dsubmenu>
        </xl-tree-member-modal>
        <jw-dsubmenu :disabled="data.groupList?.length" @click="addUserDepart">{{ $t('租户群组') }}</jw-dsubmenu>
        <jw-dsubmenu :value="2" class="node-data-submenu" trigger="click">
          <template #default> {{ $t('选择该对象下的人员字段') }}</template>
          <template #content>
            <div style="padding: 0 15px 0 10px">
              <jw-doption :title="item.label" v-for="item in data.entityUserList" :key="item.value" :value="item.value" class="node-data-option" :disabled="hasChecFieldkList.includes(item.value)" @click="handleSelectUserField(item)">{{ item.label }}</jw-doption>
            </div>
          </template>
        </jw-dsubmenu>
        <jw-doption :disabled="data.owners.length" @click="handleOwner">{{ $t('节点负责人') }}</jw-doption>
      </template>
    </jw-select>
  </div>
  <teleport to="body">
    <jw-modal titleAlign="start" :title="$t('请选择群组')" v-model:visible="data.memberDialog" width="400px" :mask-closable="false">
      <div style="margin: -20px 0 5px 0">
        <jw-input-search v-model="data.searchGroupName" @press-enter="searchGroups(data.searchGroupName)" @search="searchGroups" allow-clear :placeholder="$t('输入关键字进行搜索')" />
      </div>
      <jw-spin :loading="loading" :tip="$t('数据加载中') + '……'" :style="{ width: '100%' }">
        <div style="height: 400px; overflow: auto">
          <jw-checkbox-group v-model="data.groupId" @change="changeGroupList" v-if="data.groupList?.length">
            <template v-for="item in data.groupList ? data.groupList : data.groupListLast" :key="item.value">
              <div>
                <jw-checkbox :value="item.id">
                  <template #checkbox="{ checked }">
                    <span class="custom-checkbox-card" :class="{ 'custom-checkbox-card-checked': checked }" :checked="checked" checkable>
                      <jw-space>
                        <jw-avatar :size="22">
                          <img :src="item?.avatar" />
                        </jw-avatar>
                        {{ item.name }}
                      </jw-space>
                    </span>
                  </template>
                </jw-checkbox>
              </div>
            </template>
          </jw-checkbox-group>
          <jw-empty v-else />
        </div>
      </jw-spin>
      <template #footer>
        <jw-space>
          <jw-button @click="cancelDialog">{{ $t('取消') }}</jw-button>
          <jw-button type="primary" @click="addGroupHandle">{{ $t('确定') }}</jw-button>
        </jw-space>
      </template>
    </jw-modal>
  </teleport>
</template>

<script setup>
import { reactive, ref, computed, onMounted, watch, inject } from 'vue';
import { setService } from '@/api/';
// import { Message } from '@arco-design/web-vue';
import { tools } from '@/utils/tools';
import useLoading from '@/hooks/loading';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const { loading, setLoading } = useLoading(false);
const emits = defineEmits(['cb']);
const props = defineProps({
  recipient: {
    type: Object,
    default: () => {}
  },
  groupList: {
    type: Array,
    default: () => []
  },
  allUserTypeFields: {
    type: Array,
    default: () => []
  }
});
const groupListLast = computed(() => props.groupList); // 群组信息
const data = reactive({
  recipient: {
    userList: [] //人员
  },
  memberRecord: [], //人员记录
  triggerAction: inject('flowStepParams')?.triggerAction, //触发动作
  title: t('新增的记录'),
  recordList: inject('flowStepParams')?.memberRecord, //编辑时回显上一步选择的记录
  memberDialog: false,
  userDept: [], //接收人
  userIds: [], //人员id
  groupId: [], //群组id
  modifyId: [], //修改的记录id
  fieldIds: [], //人员字段
  groupListLast: groupListLast.value || [],
  groupList: [], //群组列表
  searchGroupName: '',
  groupName: [],
  modifyName: [],
  userNameList: [],
  userFieldsList: [], // 对象下人员字段
  owners: [],
  entityUserList: props.allUserTypeFields
    ?.filter((fItem) => fItem.fieldType === 6 || (fItem.fieldType === 21 && fItem?.business?.fieldType === 6))
    ?.map((aItem) => {
      return {
        label: aItem.fieldName,
        value: aItem.fieldKey
      };
    })
});
console.log('所有人员类型字段', data.entityUserList);
watch(
  () => data.triggerAction,
  (v) => {
    if (v === 30) {
      data.title = t('新增的记录');
    } else if (v === 40) {
      data.title = t('修改的记录');
    } else if (v === 50) {
      data.title = t('满足条件的记录');
    }
  },
  { deep: true }
);
const getVal = (v) => {
  const userNames = computed(() =>
    v?.userList?.map((u) => {
      return { label: u.userName, value: u.id };
    })
  );
  data.recipient.userList = v?.userList;
  data.userIds = data?.recipient?.userList.map((c) => c.id);
  data.userNameList = [...userNames.value];
};

// 选择节点负责人
const handleOwner = (dValue) => {
  console.log('选择节点负责人', dValue.target.value);
  data.owners = [
    {
      label: '节点负责人',
      value: 'owners'
    }
  ];
  console.log('节点负责人123', data.owners);
};
//删除选中数据
const removeUserDepart = (removed) => {
  console.log('删除项', removed);
  data.modifyId = JSON.parse(JSON.stringify(data.modifyId));
  data.modifyName = JSON.parse(JSON.stringify(data.modifyName));
  const userItem = data?.recipient?.userList?.findIndex((item) => item.userName === removed.label);
  const userId = data?.recipient?.userList?.find((item) => item.userName === removed.label)?.id;
  // 处理人员选择的删除
  if (userItem !== -1) {
    data.recipient.userList?.splice(userItem, 1);
    data.userIds.forEach((item, index) => {
      if (item.value == userId) {
        data.userIds.splice(index, 1);
      }
    });
  }
  // 处理群组的删除
  data.groupList = JSON.parse(JSON.stringify(data.groupListLast)); //重新复制以免删除的时候找不到（经过筛选后可能找不到要删除的这个value）
  data.userNameList = data.userNameList?.filter((item) => item.value !== removed.value);
  const group = data.groupList?.find((item) => item.id === removed.value)?.id;
  data.groupId = data.groupId?.filter((item) => item !== group);
  // console.log(193, data.groupList, data.groupId);
  data.groupName = data.groupName?.filter((item) => item.value !== removed.value);
  // 处理记录的删除及解除禁用
  console.log(185, data.memberRecord, data.modifyId, data.modifyName);
  data.memberRecord?.forEach((item, i) => {
    console.log(191, item);
    // 判断删除中removed.step和item.step是否一致，一致则删除对应的步骤并解除禁用状态
    // 此处开始添加的step，判断step是处理新数据，else是兼容老数据（当时还没有step字段）
    if (removed?.fieldKey) {
      item.list?.forEach((record, ind) => {
        record.memberList?.forEach((val, index) => {
          // 支持多对象的字段一定会有removed.fieldKey,之前的不会有
          if (removed.step == val.step) {
            //找到这个字段
            if (removed?.fieldKey == val.value) {
              // isSelf=true代表本人，isSelf=false代表本人上级
              if (removed.isSelf) {
                data.memberRecord[i].list[ind].memberList[index].selfDisabled = false;
                data.modifyId = data.modifyId?.filter((item) => tools.isJSON(item.selfMsg) && JSON.parse(item.selfMsg)?.label !== removed?.label);
                data.modifyName = data.modifyName?.filter((f) => f.label !== removed.label);
              } else {
                data.memberRecord[i].list[ind].memberList[index].levelDisabled = false;
                data.memberRecord[i].list[ind].memberList[index].currentIdPre = 1;
                console.log(212, val, data.modifyId, data.modifyName);
                data.modifyId = data.modifyId?.filter((item) => tools.isJSON(item.selfMsg) && JSON.parse(item.selfMsg)?.label !== removed?.label);
                data.modifyName = data.modifyName?.filter((f) => f.label !== removed.label);
              }
            }
          }
        });
      });
    } else {
      // 此处兼容历史数据，之后新加的数据都会有这两个字段（之前是没有的）
      // 以下是为了兼容之前的老数据格式，selfMsg只有{label:"负责人 | 本人上级，0级",value:"负责人 | 本人上级，0级"}
      item.list?.forEach((record, ind) => {
        record.memberList?.forEach((val, index) => {
          console.log(222, val);
          if (removed.label.includes(val.label) && removed.label.includes('本人上级')) {
            //解除--某一步骤的本人上级的禁用
            data.memberRecord[i].list[ind].memberList[index].levelDisabled = false;
            data.memberRecord[i].list[ind].memberList[index].currentIdPre = 1;
          }
          if (removed.label.includes(val.label) && removed.label.includes('本人') && !removed.label.includes('上级')) {
            data.memberRecord[i].list[ind].memberList[index].selfDisabled = false;
          }
          data.modifyId = data.modifyId.filter((f) => tools.isJSON(f.selfMsg) && JSON.parse(f.selfMsg)?.label != removed?.label);
          data.modifyName = data.modifyName.filter((f) => f.label != removed.label);
        });
      });
    }
  });
  // 处理人员字段的删除
  data.userFieldsList = data.userFieldsList.filter((dItem) => dItem.value !== removed.value); // 找出删除的项
  data.fieldIds = data.fieldIds?.filter((fItem) => fItem.value !== removed.value); //删除id
  if (removed.value === 'owners') {
    data.owners = [];
  }
  console.log(2020, removed, data.fieldIds);
};
//清空所有
const clearAll = () => {
  data.memberRecord?.forEach((item) => {
    item.list.forEach((record) => {
      record.memberList.forEach((val) => {
        val.selfDisabled = false;
        val.levelDisabled = false;
        val.currentIdPre = 1;
      });
    });
  });
  data.recipient.userList = [];
  data.userIds = [];
  data.groupId = [];
  data.modifyId = [];
  data.groupName = [];
  data.modifyName = [];
  data.userNameList = [];
  data.userDept = [];
};
//显示群组选择弹窗
const addUserDepart = async () => {
  data.searchGroupName = '';
  data.memberDialog = true;
  if (data.groupListLast?.length) {
    data.groupList = data.groupListLast;
  } else {
    await searchGroup();
  }
};
//关闭群组
const cancelDialog = () => {
  data.memberDialog = false;
};
//修改群组选择
const changeGroupList = (v) => {
  data.groupId = v;
  console.log(2260, v);
};
const uniqueById = (array) => {
  const seen = new Set();
  return array.filter((item) => {
    return !seen.has(item.value) && seen.add(item.value);
  });
};
//添加群组
const addGroupHandle = () => {
  const nameList = data.groupList
    .filter((item) => data.groupId.includes(item.id))
    .map((it) => {
      return {
        label: it.name,
        value: it.id
      };
    });
  data.groupName = uniqueById([...data.groupName, ...nameList]);
  data.memberDialog = false;
};

// 搜索群组
const searchGroups = (val) => {
  data.searchGroupName = val;
  searchGroup({ name: val });
};
//获取群组
const searchGroup = async (params) => {
  try {
    setLoading(true);
    if (params?.name) {
      const json = await setService.getGroupList(params);
      data.groupList = JSON.parse(json.result)?.map((item) => ({
        name: item.name,
        id: item.chat_id,
        avatar: item.avatar
      }));
    } else {
      data.groupList = data.groupListLast;
    }
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.log(e);
  }
};

// 已选人员集合
const hasChecFieldkList = computed(() => {
  return data.userFieldsList?.map((dItem) => dItem.value);
});

// 选择人员字段
const handleSelectUserField = (v) => {
  const userFields = v;
  data.userFieldsList = [...data.userFieldsList, userFields]; // 赋值给data人员字段
};
// 回显数据处理
// const processMemberRecord = (memberRecord, modifyId) => {
//   // 深拷贝原始数据
//   const recordList = JSON.parse(JSON.stringify(memberRecord));
//   // 遍历需要修改的项
//   modifyId?.forEach((modifyItem) => {
//     // console.log(310, modifyItem);
//     // 遍历原始数据
//     recordList.forEach((item) => {
//       // console.log(311, item);
//       // 判断回显的数据的步骤是否一致，一致才向下比较
//       const step = modifyItem?.step || (tools.isJSON(modifyItem?.selfMsg) && JSON.parse(modifyItem?.selfMsg)?.step);
//       if (step !== item.step) {
//         return; // 步骤不一致，跳过当前项
//       }
//       // 遍历列表项
//       item.list?.forEach((listItem) => {
//         listItem?.memberList?.forEach((v) => {
//           // console.log(369, v, modifyItem);
//           if (v.value === modifyItem.value) {
//             // 更新对应的属性值
//             v.selfDisabled = modifyItem.selfDisabled;
//             v.levelDisabled = modifyItem.levelDisabled;
//             v.currentIdPre = modifyItem.levelDisabled ? modifyItem.currentIdPre : 1;
//           }
//         });
//       });
//     });
//   });
//   return recordList;
// };

// 初始化
const init = async () => {
  const recipients = computed(() => props.recipient); //回显数据

  console.log('初始化123', recipients.value);
  // eslint-disable-next-line no-debugger
  // debugger;
  data.userIds = recipients?.value?.users?.map((aItem) => aItem) || [];
  data.groupId = recipients?.value?.chats?.map((aItem) => aItem) || [];
  data.owners = recipients?.value?.owners?.map((aItem) => aItem) || [];
  data.userFieldsList = recipients?.value?.fields || [];

  // console.log(354, data.memberRecord, data.recordList);
  if (data.groupId.length > 0) {
    if (Array.isArray(data.groupId) && typeof data.groupId[0] === 'object') {
      data.groupId = data.groupId?.map((item) => item.value);
    }
    if (data.groupListLast?.length) {
      data.groupName = data.groupListLast
        ?.filter((item) => data.groupId?.includes(item.id))
        ?.map((it) => {
          return {
            label: it.name,
            value: it.id
          };
        });
    } else {
      data.groupName = data.groupList
        ?.filter((item) => data.groupId?.includes(item.id))
        ?.map((it) => {
          return {
            label: it.name,
            value: it.id
          };
        });
    }
  }
  if (data.userIds.length) {
    const keys = Object.keys(data.userIds[0]);
    if (keys.length > 1) {
      data.recipient.userList = data.userIds?.map((v) => {
        return {
          ...v,
          userName: v.userName,
          avatarOrigin: v.avatarOrigin
        };
      });
      data.userNameList = data.userIds?.map((item) => {
        return {
          label: item?.userName,
          value: item?.id
        };
      });
    }
  }
};
onMounted(async () => {
  // await searchGroup();
});
const receivers = ref([]); //提交的数据
watch(
  [() => data.groupName, () => data.modifyName, () => data.userNameList, () => data.userFieldsList, () => data.owners],
  () => {
    data.userDept = [...data.userNameList, ...data.groupName, ...data.modifyName, ...data.userFieldsList, ...data.owners];
    // 判断data.groupId是简单数组还是数组对象
    console.log('已选数据0', data.userDept, data.owners);
    if (Array.isArray(data.userIds) && data.userIds.length > 0) {
      data.userIds = data.userIds?.map((item) => {
        if (typeof item === 'object') {
          return item;
        } else {
          return { value: item };
        }
      });
    }
    if (Array.isArray(data.groupId) && data.groupId.length > 0 && typeof data.groupId[0] !== 'object') {
      data.groupId = data.groupId?.map((item) => ({ value: item }));
    }
    console.log(431, data.modifyId, data.modifyName);
    if (data.modifyId?.length) {
      data.modifyId?.forEach((item) => {
        if (typeof item.selfMsg === 'object') {
          item.selfMsg = JSON.stringify(item.selfMsg);
        }
      });
    }

    if (data.userFieldsList.length) {
      data.fieldIds = data.userFieldsList?.map((dItem) => ({ value: dItem.value }));
    }

    receivers.value[0] = { receiverInfos: data.userNameList, receiverType: 1 };
    receivers.value[1] = { receiverInfos: data.groupName, receiverType: 2 };
    receivers.value[2] = { receiverInfos: data.modifyId, receiverType: 3 };
    receivers.value[3] = { receiverInfos: data.userFieldsList, receiverType: 4 };

    const emitsParams = {
      user: data.userNameList?.map((mItem) => {
        return {
          id: mItem.value,
          userName: mItem.label
        };
      }),
      chats: data.groupName,
      fields: data.userFieldsList,
      owners: data.owners
    };

    console.log('已选数据', emitsParams);

    emits('cb', emitsParams);
    if (data.groupId.length > 0 && Array.isArray(data.groupId) && typeof data.groupId[0] === 'object') {
      data.groupId = data.groupId?.map((item) => item.value);
    }
    // if (data.userIds.length > 0 && Array.isArray(data.userIds) && typeof data.userIds[0] === 'object') {
    //   data.userIds = data.userIds?.map((item) => item.value);
    // }
  },
  { deep: true }
);
watch(
  () => data.groupListLast,
  async (v) => {
    console.log(327, v);
    if (v?.length) {
      data.groupList = v;
    } else {
      await searchGroup();
    }
    await init();
  },
  { deep: true, immediate: true }
);
watch(
  () => data.recordList,
  async (v) => {
    console.log(378, v);
    await init();
  },
  { deep: true, immediate: true }
);
const tree = ref({
  isAll: true
});
</script>
<style scoped lang="less">
@import './ly-recipient.less';
</style>
